/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogoService {

  constructor(private userService: UserService) { }

  logoDetails: any;
  isOrgLogoSet = false;
  orgId: number = this.userService.getOrgId();
  isAlertOpen = false;
  orgLogo: string | undefined;

  getLogoPath(orgId: any = '') {
    const logos = environment.logos;
   
    const logo = logos.find(logo => logo.orgId == orgId);
   

    if (logo !== undefined) {
      this.logoDetails = logo;

      if (this.logoDetails.orgId !== 0) {

        this.userService.setOrgId(this.logoDetails.orgId);
        this.orgId = this.userService.getOrgId();
       
      }
      else {
        this.orgId = 1;
        // this.userService.setOrgId(this.orgId)
     
      }
      this.orgLogo = logo.orgLogo;
      return this.logoDetails;
    }
    else {
      this.isAlertOpen = true;
      this.logoDetails = logos.find(logo => logo.orgId === 0);
      this.orgId = 1
      // this.userService.setOrgId(this.orgId)
      this.orgLogo = this.logoDetails.orgLogo;
      return this.logoDetails;
    }
  }
  
}